module.exports = __webpack_public_path__ + "img/5.69938eb3.png";